<template>
  <div class="memberCenter_wrap ChangePassword">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/MemberCenter">首页</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>修改密码</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="back_btn" @click="back">
        返回
        <img src="@/assets/img/icon_return.png" alt />
      </div>
    </div>
    <div class="content_wrap" :style="{ height }">
      <div class="change_inform">
        <div class="title">修改密码</div>
        <el-form :model="form" :rules="rules" ref="ruleForm1" :inline-message="true">
          <el-form-item label="旧密码" class="all_line" prop="oldPassword">
            <el-input show-password v-model="form.oldPassword"></el-input>
          </el-form-item>
          <el-form-item label="新密码" class="all_line" prop="newPassword">
            <el-input show-password v-model="form.newPassword"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" class="all_line" prop="surePassword">
            <el-input show-password v-model="form.surePassword"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn_wrap">
        <span class="btn_1" @click="Reset">重 置</span>
        <span class="btn_1" @click="changePwd">确 定</span>
      </div>
    </div>
  </div>
</template>

<script>
import { validatePass, validatePass2 } from '@/assets/js/util'
import jsSHA from '@/assets/js/sha.js'
export default {
  data() {
    return {
      height: document.body.clientHeight - 120 + 'px',
      form: {
        oldPassword: '',
        newPassword: '',
        surePassword: ''
      },
      rules: {
        oldPassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPassword: [{ required: true, validator: validatePass, trigger: 'blur' }],
        surePassword: [{ required: true, validator: validatePass2, trigger: 'blur' }]
      }
    }
  },
  methods: {
    back() {
      this.$router.push('/MemberCenter')
    },
    quit() {
      window.localStorage.removeItem('loginToken')

      this.$router.push({ path: '/' })
    },
    changePwd() {
      this.$refs.ruleForm1.validate((valid) => {
        if (valid) {
          var shaObj = new jsSHA(this.form.oldPassword, 'TEXT')
          var oldloginPwdHash = shaObj.getHash('SHA-1', 'HEX')

          var shaObj1 = new jsSHA(this.form.newPassword, 'TEXT')
          var newloginPwdHash = shaObj1.getHash('SHA-1', 'HEX')

          this.postRequest('SupplierLogin/UpdateLoginPwd', {
            oldPassword: oldloginPwdHash,
            newPassword: newloginPwdHash
          })
            .then((res) => {
              if (res.data.errcode == 0) {
                this.$message({ type: 'success', message: '修改成功！' })
                this.quit()
              } else {
                this.$message.error(res.data.errmsg)
              }
            })
            .catch(function (error) {})
        }
      })
    },
    Reset() {
      this.form = {}
    }
  }
}
</script>

<style lang="scss" scoped>
.ChangePassword {
  ::v-deep .el-form {
    width: 600px;
    margin: 20px auto;
  }
  .btn_wrap {
    width: 366px;
    margin: 60px auto 0;
    // .btn_1 {
    //   border-radius: 10px;
    //   background: #0774c5;
    //   color: #fff;
    // }
  }
}
.back_btn {
  height: 26px;
  bottom: 7px;
  padding: 0 18px;
  border-radius: 14px;
}
</style>
